import * as React from "react";
import { I18N_NS } from "Config/i18n";
import { Button, Form, Input } from "antd";
import { useTranslation } from "react-i18next";
import { useForm } from "antd/es/form/Form";
import { ModalComponentProps } from "Components/General/Modal/ModalContext";
import { notificationSuccess } from "utils/libHelpers/AntdNotification";
import { API } from "General/API";
import { API_URL } from "General/APIEndpoints";

interface TeamsWidgetFormProps extends ModalComponentProps {
  email?: string;
}

export const TeamsWidgetForm = (props: TeamsWidgetFormProps) => {
  const { t } = useTranslation(I18N_NS.GENERAL);
  const [form] = useForm();

  const handleFinish = async (values) => {
    console.log("values", values);
    const formData: API_FeedbackRequest = {
      email: values.email,
      text: values.text,
    };
    await API.newData(API_URL.TEAMS_FEEDBACK.sendFeedback(), formData);
    props.hideModal();
    notificationSuccess(t("Success"), t("Message was sent"));
  };

  React.useEffect(() => {
    form.setFieldsValue({ email: props.email });
  }, [props.email]);

  return (
    <Form
      form={form}
      requiredMark={false}
      initialValues={{ email: props.email }}
      layout="vertical"
      onFinish={handleFinish}
    >
      <Form.Item label={t("Email")} name="email" rules={[{ required: true, message: t("This field is required") }]}>
        <Input type="email" />
      </Form.Item>
      <Form.Item label={t("Message")} name="text" rules={[{ required: true, message: t("This field is required") }]}>
        <Input.TextArea autoSize={{ minRows: 4 }} />
      </Form.Item>
      <div className="text-right">
        <Button type="primary" htmlType="submit">
          {t("Send")}
        </Button>
      </div>
    </Form>
  );
};
